module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "钉钉用户",
      "width": "600px"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "editDingForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.dingRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "钉钉用户",
      "prop": "dingtalkUserid"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dingtalkUserid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dingtalkUserid", $$v)
      },
      expression: "formData.dingtalkUserid"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Option', {
      key: item.userId,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(_vm._s(item.userName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否接收钉钉消息",
      "prop": "isReceiveMsg"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.isReceiveMsg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isReceiveMsg", _vm._n($$v))
      },
      expression: "formData.isReceiveMsg"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.saveDing
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17edaa20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/modal/TeachersDingTalkModal.vue
// module id = 1670
// module chunks = 8